import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import SynthesisPlannerSimilarityReaction from '@Components/Results/synthesis-planner/SynthesisPlannerSimilarityReaction';
import Loader from '@Components/Loader';

import './SimilaritySearchGrid.scss';

function SimilaritySearchGrid({ results = [], onSubmit = () => null, totalItems, isLoadingMore }) {
  const hideSimilarityColumn = useMemo(() => results.every((reaction) => reaction.similarityPercentage == null), [results]);

  return (
    <>
      <div className="similarity-search-grid__header">
        <div className="modal-synthesize-table-headers">
          <div className={cn(`col-similarity-reaction-${hideSimilarityColumn ? 5 : 3}`, 'text-center')}>Structure ({totalItems})</div>
          {!hideSimilarityColumn && <div className="col-similarity-reaction-2 text-center">Similarity</div>}
          <div className="col-similarity-reaction-3 text-center">Chemical Name</div>
          <div className="col-similarity-reaction-2 text-center">Number of references</div>
          <div className="col-similarity-reaction-2 text-center">Number of preparations</div>
        </div>
      </div>
      <div className="similarity-search-grid__container">
        {results.map((reaction, i) => (
          <SynthesisPlannerSimilarityReaction
            className="similarity-search-grid__item"
            reaction={reaction}
            submit={() => onSubmit(reaction)}
            key={`similar-reaction-${i}`}
            hideSimilarityColumn={hideSimilarityColumn}
          />
        ))}
        {isLoadingMore && (
          <div className="similarity-search-grid__loader">
            <Loader loaded={false} />
          </div>
        )}
      </div>
    </>
  );
}

SimilaritySearchGrid.propTypes = {
  results: PropTypes.array,
  onSubmit: PropTypes.func,
  totalItems: PropTypes.number,
  isLoadingMore: PropTypes.bool,
};

export default SimilaritySearchGrid;
